const SIN_DATO = '—';

const esNumero = (valor) => valor !== null && valor !== undefined && !isNaN(Number(valor));

export const formatoNumero = (valor) =>
    esNumero(valor) ? Number(valor).toLocaleString('es-CO') : SIN_DATO;

export const formatoMoneda = (valor) =>
    esNumero(valor) ? `$ ${Number(valor).toLocaleString('es-CO', { maximumFractionDigits: 0 })}` : SIN_DATO;

export const formatoPorcentaje = (valor) =>
    esNumero(valor) ? `${Number(valor).toFixed(1)}%` : SIN_DATO;

export const FORMATOS = {
    numero: formatoNumero,
    moneda: formatoMoneda,
    porcentaje: formatoPorcentaje
};

const dosDigitos = (n) => String(n).padStart(2, '0');

export const fechaISO = (fecha) =>
    `${fecha.getFullYear()}-${dosDigitos(fecha.getMonth() + 1)}-${dosDigitos(fecha.getDate())}`;

export const periodoPorDefecto = () => {
    const hoy = new Date();
    return {
        periodoDesde: fechaISO(new Date(hoy.getFullYear(), hoy.getMonth(), 1)),
        periodoHasta: fechaISO(hoy)
    };
};
